import * as global_constants from './../../global_constants';
import { RequestConfig } from './../../shared/network/config';
import { Request } from './../../shared/network/request';
import * as AppliedModifiersConstants from '../constant/applied_modifiers_constants';


export const get_applied_modifiers = (token) => {

    const url = `${global_constants.base_end_points}${global_constants.end_points.applied_modifiers_url.get_applied_modifiers}`;
    let request = new Request();
    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
    }

    let requestConfig = new RequestConfig({
        'url': url,
        'headers': headers,
        'method': 'get'
    })

    return request.make(requestConfig);
};

export const get_revenue_centers_and_proc_codes = (token, companyId) => {
    const url = `${global_constants.base_end_points}${global_constants.end_points.applied_modifiers_url.revenue_centers_and_proc_codes.replace('{companyId}', companyId)}`;
    let request = new Request();
    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
    }
    let requestConfig = new RequestConfig({
        'url': url,
        'headers': headers,
        'method': 'get'
    })
    return request.make(requestConfig);
};

export const validate_applied_modifier = (token, appliedModifierData) => {
    const url = `${global_constants.base_end_points}${global_constants.end_points.applied_modifiers_url.validate_applied_modifier}`;
    let request = new Request();
    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
    }

    let requestConfig = new RequestConfig({
        'url': url,
        'headers': headers,
        'method': 'post',
        'data': appliedModifierData
    })

    return request.make(requestConfig);
}

export const save_applied_modifier = (token, appliedModifierData) => {
    const url = `${global_constants.base_end_points}${global_constants.end_points.applied_modifiers_url.save_applied_modifier}`;
    let request = new Request();
    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
    }

    let requestConfig = new RequestConfig({
        'url': url,
        'headers': headers,
        'method': 'post',
        'data': appliedModifierData
    })

    return request.make(requestConfig);
}

export const get_applied_modifiers_payer = (token) => {
    const url = `${global_constants.base_end_points}${global_constants.end_points.procedure_code_replacement_url.payer}`;
    let request = new Request();
    let headers = {
        'Authorization': 'Bearer ' + token,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }

    let requestConfig = new RequestConfig({
        'url': url,
        'headers': headers,
        'method': 'get'
    })

    return request.make(requestConfig);
};

export const get_applied_modifiers_insurance_class = (token) => {
    const url = `${global_constants.base_end_points}${global_constants.end_points.procedure_code_replacement_url.insurance_class}`;
    let request = new Request();
    let headers = {
        'Authorization': 'Bearer ' + token,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }

    let requestConfig = new RequestConfig({
        'url': url,
        'headers': headers,
        'method': 'get'
    })

    return request.make(requestConfig);
};


export const get_state_locations = (token) => {
    const url = `${global_constants.base_end_points}${global_constants.end_points.applied_modifiers_url.get_state_locations}`;
    let request = new Request();
    let headers = {
        'Authorization': 'Bearer ' + token,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }

    let requestConfig = new RequestConfig({
        'url': url,
        'headers': headers,
        'method': 'get'
    })

    return request.make(requestConfig);
}

export const get_provider_types = (token) => {
    const url = `${global_constants.base_end_points}${global_constants.end_points.applied_modifiers_url.get_provider_types}`;
    let request = new Request();
    let headers = {
        'Authorization': 'Bearer ' + token,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }

    let requestConfig = new RequestConfig({
        'url': url,
        'headers': headers,
        'method': 'get'
    })

    return request.make(requestConfig);
}